export default __webpack_public_path__ + "static/media/usaFlagButton.6f0ca374.png";